/**
 * @author Fernando Ruano
 * @file index.js
 * @description ModalOptions Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Drawer, Button, Divider } from 'antd';

// Styles
import styles from './styles.module.css';

const StyledDrawer = styled(Drawer)`
  &.ant-drawer-bottom.ant-drawer-open .ant-drawer-content-wrapper {
    background-color: transparent;
    width: 95%;
    margin-bottom: 20px;
    transform: translateX(-50%);
    margin-left: 50%;
    height: 66px !important;
    @media (min-width: 768px) {
      max-width: 400px;
    }
  }

  &.ant-drawer .ant-drawer-content {
    border-radius: 20px;
  }

  &.ant-drawer > * {
    transition: 0ms;
  }
`;

/**
 * ModalOptions Component.
 * @return { Node } React ModalOptions Component.
 */
const ModalOptions = ({
  modalOptions,
  closeOptionText,
  visible,
  setVisible,
  placement
}) => {
  const { t: translate } = useTranslation();

  return (
    <StyledDrawer
      bodyStyle={{
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      destroyOnClose
      title=""
      placement={placement}
      closable={false}
      onClose={() => setVisible(false)}
      visible={visible}>
      <div className={styles.quitBlock2}>
        {modalOptions.map((itm, indx) => {
          return (
            <div key={indx}>
              <div
                onClick={itm.onClick}
                className="pl-5 flex flex-row items-center cursor-pointer">
                {itm.icon}
                <h3 className={`pl-3 py-3 mb-0 font-medium text-${itm.type}`}>
                  {translate(itm.textOption)}
                </h3>
              </div>
              {indx !== modalOptions.length - 1 && (
                <Divider style={{ margin: 0, backgroundColor: '#f0f0f7' }} />
              )}
            </div>
          );
        })}
      </div>
      <Button
        onClick={() => setVisible(false)}
        type="link"
        className={styles.stepTwoButton2}>
        {translate(closeOptionText)}
      </Button>
    </StyledDrawer>
  );
};

/**
 * @name ModalOptions.propTypes
 * @type { Object }
 */
ModalOptions.propTypes = {
  modalOptions: PropTypes.array,
  closeOptionText: PropTypes.string,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  placement: PropTypes.string
};

/**
 * Default props
 */
ModalOptions.defaultProps = {
  placement: 'bottom',
  visible: false,
  closeOptionText: 'commons.cancel'
};

export default ModalOptions;
